import {Professions} from 'Models'


export default {
    computed: {
        isDemo() {
            return Professions.getSelected().code()==='Dem' ||
                   Professions.getSelected().isDemo()
        },
    },

    methods: {
        redirectIfDemo() {
            if(this.isDemo)
                this.$router.replace({name: 'dashboard'})
        }
    }
}